import React, { Component } from 'react'
// eslint-disable-next-line
import { Link, Navigate, Route, Routes } from 'react-router-dom'

import { connect } from "react-redux"
import { increment, decrement } from "../features/counter/counterSlice"
import { setLoggedIn } from "../features/account/loginSlice"
import { setAccount } from "../features/account/accountSlice"
import { setCompany } from "../features/account/companySlice"

import axios from "axios";
import qs from 'qs';
import Swal from 'sweetalert2';

import { hidePreloader, showPreloader } from '../library/helper';
import { withTranslation } from 'react-i18next';
import { withRouter } from '../components/withRouter'

import "react-datepicker/dist/react-datepicker.css";

export class OfficeUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectOffice: false,
            selectedCompany: 0,
            inputBuilding: "",
            inputAddress: "",
            listCompany: [],
            selectedID: "",
        }
    }

    componentDidMount = async () => {
        showPreloader();

        const optionsGetCompany = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify({}),
            url: `${process.env.REACT_APP_BASE_SERVER}/client/company`
        };
        const responseGetCompany = await axios(optionsGetCompany);
        if (responseGetCompany.data.success) {
            this.setState({ listCompany: responseGetCompany.data.data })
        }

        const { id } = this.props.params
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify({ id }),
            url: `${process.env.REACT_APP_BASE_SERVER}/client/office/read`
        };
        const response = await axios(options);
        if (response.data.success) {
            this.setState({
                selectedID: id,
                selectedCompany: response.data.data[0].office_company,
                inputBuilding: response.data.data[0].office_name,
                inputAddress: response.data.data[0].office_address,
            })
        }

        hidePreloader();
    }

    onSelectCompany = async (e) => {
        let companyValue = e.target.value;
        this.setState({
            selectedCompany: companyValue,
        })
    }

    onInputBuilding = async (e) => {
        let buildingValue = e.target.value;
        this.setState({
            inputBuilding: buildingValue,
        })
    }

    onInputAddress = async (e) => {
        let addressValue = e.target.value;
        this.setState({
            inputAddress: addressValue,
        })
    }

    onSaveRecordCall = async (data) => {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `${process.env.REACT_APP_BASE_SERVER}/client/office/update`
        };
        const response = await axios(options);
        if (response.data.success) {
            return true;
        } else {
            return false;
        }
    }

    onSaveRecord = async (e) => {
        let invalidData = true;

        let company = this.state.selectedCompany;
        let building = this.state.inputBuilding;
        let address = this.state.inputAddress;

        console.log(company)
        console.log(building)
        console.log(address)

        // eslint-disable-next-line
        if (building != "" && address != "" && company != 0) {

            const data = {
                'company': this.state.selectedCompany,
                'building': this.state.inputBuilding,
                'address': this.state.inputAddress,
                'id': this.state.selectedID,
            };
            console.log(data)
            const result = this.onSaveRecordCall(data);
            //const result = false;
            if (result) {
                invalidData = false;
            }
        }
        if (invalidData) {
            Swal.fire({
                title: '',
                html: '<p>Please fill all information needs</p>',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            })
        } else {
            Swal.fire({
                title: '',
                html: '<p>Successfully record location</p>',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        redirectOffice: true
                    })
                }
            })
        }
    }

    render() {
        const { redirectOffice } = this.state;
        const { listCompany, selectedCompany } = this.state;

        if (redirectOffice) {
            return <Navigate to={'/location'} />
        }

        let optionCompany = [];
        optionCompany.push(selectedCompany > 0 ? null : <option key={0} value={0}>Select Company</option>)
        // eslint-disable-next-line
        if (listCompany != undefined) {
            if (listCompany.length > 0) {
                listCompany.map(async (item, index) => {
                    optionCompany.push(<option key={index + 1} value={item.company_id}>{item.company_name}</option>)
                })
            }
        }

        return (
            <div className="page-content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">{this.props.t('menu.label623')}</h4>

                                {/*<div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="#page">Pages</a></li>
                                        <li className="breadcrumb-item active">Starter</li>
                                    </ol>
                                </div>*/}

                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">{this.props.t('general.btnUpdate')}</h4>
                                </div>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="company" className="form-label">{this.props.t('menu.label622')}</label>
                                                <select onChange={e => this.onSelectCompany(e)} value={this.state.selectedCompany} id="company" name="company" className="form-select mb-3">
                                                    {optionCompany}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label htmlFor="company" className="form-label">{this.props.t('menu.label623')}</label>
                                                <input id="company" name="company" type="text" className="form-control" placeholder={this.props.t('menu.label623')} value={this.state.inputBuilding} onChange={(e) => this.onInputBuilding(e)} />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="company" className="form-label">{this.props.t('location.label1')}</label>
                                                <input id="company" name="company" type="text" className="form-control" placeholder={this.props.t('location.label1')} value={this.state.inputAddress} onChange={(e) => this.onInputAddress(e)} />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="text-end">
                                                <button onClick={this.onSaveRecord} type="submit" className="btn btn-primary">{this.props.t('general.btnSave')}</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    count: state.counter.value,
    loggedIn: state.loggedIn.value,
    account: state.account.value,
    company: state.company.value,
});

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany };

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OfficeUpdate)))
